import { FC, ReactNode } from 'react';
import styles from './ModalFactoidsList.css';

interface IModalFactoidsListProps {
  list: ReactNode;
}

export const ModalFactoidsList: FC<IModalFactoidsListProps> = ({ list }) => {
  return <div className={styles['factoids-list']}>{list}</div>;
};
